export default __webpack_public_path__ + "37fea8551927d0ce4171610367583318.ttf";